import { Shell, StepFooter } from "@/components/Shell";
import { ScaleInput } from "@/components/ScaleInput";
import { IMPACT_QUESTIONS } from "@/lib/questions";

export function ImpactStep({ answers, setAnswer, onBack, onNext, progress }) {
  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Impacto</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        ¿Cuánto te afecta día a día?
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Valora el impacto general que tienen estos síntomas en tu vida.
      </p>

      <div className="mt-6 space-y-4">
        {IMPACT_QUESTIONS.map((q) => (
          <ScaleInput
            key={q.id}
            questionId={q.id}
            label={q.text}
            value={answers[q.id]}
            onChange={(v) => setAnswer(q.id, v)}
          />
        ))}
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="impact-back-btn">
          Atrás
        </button>
        <button onClick={onNext} className="cc-btn-primary" data-testid="impact-next-btn">
          Continuar
        </button>
      </StepFooter>
    </Shell>
  );
}
